const common = {
  // Shared buttons & labels
  save: 'सहेजें',
  cancel: 'रद्द करें',
  submit: 'जमा करें',
  next: 'अगला',
  back: 'वापस',
  previous: 'पिछला',
  confirm: 'पुष्टि करें',
  delete: 'हटाएं',
  edit: 'संपादित करें',
  close: 'बंद करें',
  search: 'खोजें',
  filter: 'फ़िल्टर',
  clear: 'साफ़ करें',
  loading: 'लोड हो रहा है...',
  yes: 'हाँ',
  no: 'नहीं',
  viewAll: 'सभी देखें',
  showLess: 'कम दिखाएं',
  showMore: 'और दिखाएं',
  home: 'होम',
  dashboard: 'डैशबोर्ड',
  settings: 'सेटिंग्स',
  // Form-related
  emailAddress: 'ईमेल पता',
  password: 'पासवर्ड',
  fullName: 'पूरा नाम',
  dateOfBirth: 'जन्म तिथि',
  address: 'पता',
  district: 'जिला',
  townCity: 'शहर / कस्बा',
  contactNumber: 'संपर्क नंबर',
  mobileNumber: 'मोबाइल नंबर',
  status: 'स्थिति',
  actions: 'कार्रवाइयाँ',
  // UI elements
  noResults: 'कोई परिणाम नहीं मिला',
  noData: 'कोई डेटा उपलब्ध नहीं',
  selectOption: 'एक विकल्प चुनें',
  required: 'आवश्यक',
  optional: 'वैकल्पिक',
  // Time
  today: 'आज',
  tomorrow: 'कल',
  yesterday: 'कल',
  goodMorning: 'सुप्रभात',
  goodAfternoon: 'नमस्कार',
  goodEvening: 'शुभ संध्या',
  // Actions
  upload: 'अपलोड करें',
  download: 'डाउनलोड करें',
  preview: 'पूर्वावलोकन',
  remove: 'हटाएं',
  add: 'जोड़ें',
  addNew: 'नया जोड़ें',
  view: 'देखें',
  viewDetails: 'विवरण देखें',
  goBack: 'वापस जाएं',
  signOut: 'साइन आउट',
  // Profile & permissions
  profile: 'प्रोफ़ाइल',
  effectivePermissions: 'प्रभावी अनुमतियाँ',
  noPermissions: 'कोई फ़ीचर अनुमति असाइन नहीं की गई',
  switchRole: 'भूमिका बदलें',
  roleSwitched: '{{role}} भूमिका में बदल दिया गया',
  refresh: 'रीफ़्रेश करें',
  reset: 'रीसेट करें',
  retry: 'पुनः प्रयास करें',
  // Notifications
  markAllRead: 'सभी पढ़ें के रूप में चिह्नित करें',
  noNotifications: 'कोई सूचना नहीं',
  notifications: 'सूचनाएं',
  // Language
  language: 'भाषा',
  // Help
  help: 'सहायता',
  searchPlaceholder: 'खोजें...',
  // Status labels
  active: 'सक्रिय',
  inactive: 'निष्क्रिय',
  pending: 'लंबित',
  draft: 'ड्राफ्ट',
  enrolled: 'नामांकित',
  enrolledStatus: 'नामांकित',
  enrolling: 'नामांकन हो रहा है',
  withdrawn: 'वापस लिया गया',
  // Misc
  all: 'सभी',
  none: 'कोई नहीं',
  other: 'अन्य',
  showing: 'दिखाया जा रहा है',
  of: 'का',
  results: 'परिणाम',
  items: 'आइटम',
  item: 'आइटम',
  students: 'छात्र',
  student: 'छात्र',
  teachers: 'शिक्षक',
  teacher: 'शिक्षक',
  staff: 'स्टाफ़',
  records: 'रिकॉर्ड',
  page: 'पेज',
  na: 'उपलब्ध नहीं',
  notAvailable: 'उपलब्ध नहीं',
  at: 'को',
  clearAllFilters: 'सभी फ़िल्टर साफ़ करें',
  backToDashboard: 'डैशबोर्ड पर वापस जाएं',
  showingCount: 'दिखाया जा रहा है',
  tryAdjustingFilters: 'अपनी खोज या फ़िल्टर समायोजित करने का प्रयास करें।',
};

export default common;